/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

import type { RouteComponent } from "vue-router";
import type { LastLevelRouteKey, RouteLayout } from "@elegant-router/types";

import BaseLayout from "@/layouts/base-layout/index.vue";
import BlankLayout from "@/layouts/blank-layout/index.vue";

export const layouts: Record<RouteLayout, RouteComponent | (() => Promise<RouteComponent>)> = {
  base: BaseLayout,
  blank: BlankLayout,
};

export const views: Record<LastLevelRouteKey, RouteComponent | (() => Promise<RouteComponent>)> = {
  403: () => import("@/views/_builtin/403/index.vue"),
  404: () => import("@/views/_builtin/404/index.vue"),
  500: () => import("@/views/_builtin/500/index.vue"),
  login: () => import("@/views/_builtin/login/index.vue"),
  affiliate: () => import("@/views/affiliate/index.vue"),
  "api-keys": () => import("@/views/api-keys/index.vue"),
  billing_credit: () => import("@/views/billing/credit/index.vue"),
  billing_history: () => import("@/views/billing/history/index.vue"),
  billing_packages: () => import("@/views/billing/packages/index.vue"),
  home: () => import("@/views/home/index.vue"),
  limits: () => import("@/views/limits/index.vue"),
  models: () => import("@/views/models/index.vue"),
  usage_overview: () => import("@/views/usage/overview/index.vue"),
  usage_reports: () => import("@/views/usage/reports/index.vue"),
};
